import { Map as ImmutableMap } from 'immutable';
import makeObjectRecord from 'customer-data-objects/record/makeObjectRecord';
import BaseObjectContents from '../objects/BaseObjectContents';
import { ImmutableObjectRecord } from '../record/ImmutableObjectRecord';

interface QuoteInboundDB extends BaseObjectContents {
  associatedObjects: Record<string, any>;
  objectId: null | number | string;
  portalId: null | number;
}

export type ImmutableQuoteInboundDBRecord =
  ImmutableObjectRecord<QuoteInboundDB>;

export default makeObjectRecord<ImmutableQuoteInboundDBRecord>(
  {
    idKey: ['objectId'],
    objectType: 'QUOTE',
    recordName: 'QuoteInboundDbRecord',
    defaults: {
      associatedObjects: ImmutableMap(),
      objectId: null,
      portalId: null,
      properties: ImmutableMap(),
    },
  },
  { primary: ['hs_title'] }
);
